import { getEnumValuesFromPipelineSchema } from '@flows/configs/shared/schemaUtils'
import type { TransformedNoContentOption } from '@flows/core/types/stepContentTypes'
import { BaseSchema_DogLiabilityV1GetsafeDe as schema } from '@flows/insurance/schemas'
import type { Enum_BreedType_1 } from '@flows/insurance/types/products/de'
import { getClaimsOptions } from '@flows/insurance/utils/stepContentUtils'
import type { getChoiceOptions } from '@flows/insurance/utils/stepContentUtils'

const deductiblesOptionsFromSchema = getEnumValuesFromPipelineSchema(schema.shape.deductible_amount)
const claimsOptionsFromSchema = getEnumValuesFromPipelineSchema(
  schema.shape.number_of_claims_in_last_5y.unwrap()
)

export const DOG_LIABILITY_NXT_CONSTANTS: {
  deductiblesOptions: string[]
  claimsOptions: ReturnType<typeof getChoiceOptions>
  sosHelpOptions: TransformedNoContentOption[]
  dogBreedTypes: Enum_BreedType_1[]
} = {
  deductiblesOptions: deductiblesOptionsFromSchema,
  claimsOptions: getClaimsOptions(claimsOptionsFromSchema.length),
  sosHelpOptions: [true, false].map((option) => ({
    label: {
      type: 'translatableText',
      translationKey: `sharedFlows_dogLiabilityNxt:steps.sos_help_coverage.options.${option}`,
    },
    value: option,
  })),
  dogBreedTypes: schema.shape.dogs.element.shape.breed_type.options,
}
